import { AftermarketPageNumber, ExteriorPageNumber, InteriorPageNumber, MechanicalPageNumber } from '../../../constants'
import { INTERIOR_TAGS, MECHANICAL_TAGS } from '../../pageMaps'

const DASHBOARD_LIGHTS = 'dashboard-lights'

const EXTERIOR_TAGS = {
  frontwithgrille: 'front',
  driverside: 'driver',
  rear: 'rear',
  passengerside: 'passenger',
  glasslights: 'wheels_lights'
}
export const CONDITION_TAGS = {
  ext: 'exterior',
  int: 'interior',
  mech: 'mechanical'
}

export const CONDITION_INDEXES = {
  ext: '019',
  int: '021',
  mech: '023'
}

const VEHICLE_CONDITION_TAGS = {
  ...EXTERIOR_TAGS,

  ...INTERIOR_TAGS,
  interior: 'seat_carpet_headliner',
  [DASHBOARD_LIGHTS]: DASHBOARD_LIGHTS,

  ...MECHANICAL_TAGS,
  'Frame & Structural': 'framemech'
}
const CONDITION_TAGS_ORDER = Object.keys(VEHICLE_CONDITION_TAGS)

const PAGE_TO_TAGS = {
  [AftermarketPageNumber]: {
    Stereo: 'stereo',
    'Wheels & Tires': 'wheels-tires',
    Suspension: 'suspension',
    Exhaust: 'exhaust',
    'Performance Modifications': 'performance'
  },
  [ExteriorPageNumber]: VEHICLE_CONDITION_TAGS,
  [InteriorPageNumber]: VEHICLE_CONDITION_TAGS,
  [MechanicalPageNumber]: VEHICLE_CONDITION_TAGS
}

export const mapIcoResponses = ({ impressionTags, icoResponses, pageInfo: { linkName = '' } }, page) => {
  if (linkName.startsWith('pic')) {
    return // E6
  }

  const mappedTags = PAGE_TO_TAGS[page]
  if (!mappedTags) return {}
  if (impressionTags.some(({ key }) => key === 'amQ')) return {}

  let pixallTags = impressionTags.filter(({ key }) => key in mappedTags)
  
  if (linkName === 'continue_modal') {
    pixallTags = Object.keys(mappedTags).map(key => ({ key }))
  }

  if (pixallTags.length === 0) {
    return icoResponses
  }

  if (isConditionPage(page)) {
    // F1, F2, G1, G2, H1, H2
    pixallTags.sort((a, b) => CONDITION_TAGS_ORDER.indexOf(a.key) - CONDITION_TAGS_ORDER.indexOf(b.key))
    pixallTags = mergeDashboardLightsTags(pixallTags)
  }

  const responseFields = pixallTags.map(({ key }) => mappedTags[key]).join('::')
  const responseValues = pixallTags.map(({ value }) => (value ? 'yes' : 'no')).join('::')
  return {
    responseFields,
    responseValues
  }
}

export const isConditionPage = page => [ExteriorPageNumber, InteriorPageNumber, MechanicalPageNumber].includes(page)

export const mergeDashboardLightsTags = tags => {
  let dashboardLightsTags = tags.filter(t => t.key in INTERIOR_TAGS && t.key !== 'interior')
  const start = tags.findIndex(t => t.key === 'ABS')
  const end = start + Object.entries(dashboardLightsTags).length

  if (end === start) return tags

  const exteriorTags = tags.slice(0, start)
  dashboardLightsTags = [{ key: DASHBOARD_LIGHTS, value: dashboardLightsTags.some(({ value }) => value) }]
  const mechTags = tags.slice(end)

  return [...exteriorTags, ...dashboardLightsTags, ...mechTags]
}

const EXTERIOR_SUB_TABS = ['front', 'driver', 'rear', 'passenger', 'windows']
const INTERIOR_SUB_TABS = ['dashboard_lights', 'seats_carpet_headliner']

export const isExteriorPage = linkName => linkName.includes('subnav') && EXTERIOR_SUB_TABS.some(suffix => linkName.includes(suffix))
export const isInteriorPage = linkName => linkName.includes('subnav') && INTERIOR_SUB_TABS.some(suffix => linkName.includes(suffix))